import React, { Component } from 'react';
import { Loading } from '../components/Loading';
import Popup from 'reactjs-popup';
import { Col, Row, Button, Alert, Form } from 'react-bootstrap';
import ServiceCalls from '../utils/serviceCalls.js';
import Autosuggest from 'react-autosuggest';
import TimedDisplay from '../components/TimedDisplay';
import ACHWarningPopUp from '../components/ACHWarningPopUp';
import { postcodeValidator, postcodeValidatorExistsForCountry } from 'postcode-validator';
import '../styles/Vendor.css';
import CommonUtils from '../utils/siteUtils';

export class VendorAddressPopUp extends Component {

    constructor(props) {
        super(props)
        this.showAlertMessage = this.showAlertMessage.bind(this);
        this.resetForm = this.resetForm.bind(this);
        this.postSubmit = this.postSubmit.bind(this);
        this.renderForm = this.renderForm.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.submitForm = this.submitForm.bind(this);
        this.getCountries = this.getCountries.bind(this);
        this.getRegions = this.getRegions.bind(this);
        this.getPopulatedCountry = this.getPopulatedCountry.bind(this);
        this.renderAddAddress = this.renderAddAddress.bind(this);
        this.renderEditAddress = this.renderEditAddress.bind(this);
        this.renderRemoveAddress = this.renderRemoveAddress.bind(this);
        this.renderSetDefaultAddress = this.renderSetDefaultAddress.bind(this);
        this.countrySelected = this.countrySelected.bind(this);
        this.onRegionSelected = this.onRegionSelected.bind(this);
        this.buildAddressSelection = this.buildAddressSelection.bind(this);
        this.onCountryNameChange = this.onCountryNameChange.bind(this);
        this.onRegionErrorFix = this.onRegionErrorFix.bind(this);
        this.onCountryErrorFix = this.onCountryErrorFix.bind(this);
        this.onCityEntered = this.onCityEntered.bind(this);
        this.onPostalEntered = this.onPostalEntered.bind(this);
        this.handleFieldChange = this.handleFieldChange.bind(this);
        this.normalizeCountryName = this.normalizeCountryName.bind(this)
        this.calculateIsModified = this.calculateIsModified.bind(this);
        //Used in 2.2 
        this.checkForPendingPayments = this.checkForPendingPayments.bind(this);
        this.state = {
            isLoaded: false,
            hasError: false,
            submitMsg: '',
            submitMsgLvl: '',
            isUpdating: false,
            isUpdateComplete: false,
            isPopupOpen: false,
            validated: false,
            countryList: [],
            regionList: [],
            countryFilteredList: [],
            regionFilteredList: [],
            dupAddress: [],
            selectedCountry: '',
            searchCountry: '',
            selectedRegion: '',
            searchRegion: '',
            enteredAddress1: '',
            enteredAddress2: '',
            enteredAddress3: '',
            countriesFetched: false,
            countrySelected: false,
            regionsFetched: false,
            invalidCountry: false,
            invalidRegion: false,
            invalidPostalCode: false,
            enteredPostalValue: '',
            enteredCityValue: '',
            regionChanged: false,
            hasPendingPayments: null,
            ACHWarningPopUpOpen: false,
            originalAddress: null,
            formData: {},
            isModified: false
        }
    }

    componentDidMount() {
    }
    //Get admin info update if props change i.e. company ID changes
    componentDidUpdate(prevProps, prevState) {
        if (this.props.editMode.toUpperCase() === "ADD" && !this.state.countriesFetched && (this.state.isPopupOpen !== prevState.isPopupOpen)) {
            if (this.state.isPopupOpen) {
                var startCountry = (this.props.vendorData.vendorSetId === 'UHGID') ? 'USA' : '';
                this.getCountries(startCountry);
            }
        }
        else if (this.props.editMode.toUpperCase() === "EDIT" && !this.state.regionsFetched && (this.state.isPopupOpen !== prevState.isPopupOpen)) {

            if (this.state.isPopupOpen) {
                this.setState({
                    enteredCityValue: this.props.currentAddress.city,
                    enteredPostalValue: this.props.currentAddress.postalCode,
                    searchRegion: this.props.currentAddress.stateProvince
                });
                this.getPopulatedCountry();
            }
        }
        else if (this.props.editMode.toUpperCase() === "INACTIVATE" && !this.state.regionsFetched && (this.state.isPopupOpen !== prevState.isPopupOpen)) {
            if (this.state.isPopupOpen) {
                this.checkForPendingPayments();
                //Duplicate 1/24/24  - this.getPopulatedCountry();

            }
        }
        else if (this.props.editMode.toUpperCase() === "SETDEFAULT" && !this.state.regionsFetched && (this.state.isPopupOpen !== prevState.isPopupOpen)) {
            if (this.state.isPopupOpen) {

                this.setState(
                    {
                        isSearching: false,
                        regionsFetched: true,
                        countrySelected: true,
                        isLoaded: true
                    }
                );
            }
        }
        // Track when searchCountry auto-clears and country auto-fills
        // Handles the case where clearing the field switches rendering branches
        // Optimized: Pre-calculate condition outside setState
        if (this.props.editMode.toUpperCase() === "EDIT" && prevState.searchCountry !== this.state.searchCountry && this.state.searchCountry.length === 0 && prevState.searchCountry.length > 0 && this.state.selectedCountry) {

            // Pre-calculate values outside setState
            const countryDisplay = `${this.state.selectedCountry.description} [${this.state.selectedCountry.country}]`;
            const updatedFormData = {
                ...this.state.formData,
                country: countryDisplay
            };
            const isModified = this.calculateIsModified(updatedFormData, this.state);
            console.log(`searchCountry cleared, auto-filling with: ${countryDisplay}`);

            // Simple setState with pre-calculated values
            this.setState({
                formData: updatedFormData,
                isModified
            });
        }
    }

    renderForm() {
        const { currentAddress, editMode } = this.props;
        switch (editMode.toUpperCase()) {
            case 'ADD':
                return this.renderAddAddress();
            case 'EDIT':
                return this.renderEditAddress(currentAddress);
            case 'INACTIVATE':
                return this.renderRemoveAddress(currentAddress);
            case 'SETDEFAULT':
                return this.renderSetDefaultAddress(currentAddress);
            default:
        }
    }
    //Used in 2.2
    checkForPendingPayments() {
        const { vendorData, currentAddress } = this.props;
        const { hasPendingPayments } = this.state;
        console.log(`Pre check for pending payments for address locations ${currentAddress.addressLocations} with Seq num ${currentAddress.addressSequenceNumber} on Supplier ${vendorData.supplierId} Pending Payments ${hasPendingPayments}`);
        if (hasPendingPayments === null) {
            ServiceCalls.getAddressPendingPayments(vendorData.supplierId, currentAddress.addressSequenceNumber, currentAddress.addressLocations).then(function (data) {

                var hasPendingPayments = (data) ? data : false;
                console.log(`After checking for pending payments for address ${currentAddress.addressLocations} on Supplier ${vendorData.supplierId} - The result: ${hasPendingPayments}`);

                this.getPopulatedCountry(hasPendingPayments);
            }.bind(this));
        }
        else {
            this.getPopulatedCountry();
        }
    }

    resetForm() {
        this.setState({
            submitMsg: '',
            submitMsgLvl: '',
            isLoaded: false,
            isUpdating: false,
            isUpdateComplete: false,
            isPopupOpen: false,
            validated: false,
            countrySelected: false,
            countriesFetched: false,
            regionsFetched: false,
            selectedCountry: '',
            searchCountry: '',
            selectedRegion: '',
            searchRegion: '',
            enteredAddress1: '',
            enteredAddress2: '',
            enteredAddress3: '',
            countryFilteredList: [],
            regionFilteredList: [],
            addressFilteredList: [],
            dupAddress: [],
            isSearching: false,
            invalidCountry: false,
            invalidRegion: false,
            invalidPostalCode: false,
            enteredPostalValue: '',
            enteredCityValue: '',
            regionChanged: false,
            hasPendingPayments: null
        });
    }
    showAlertMessage() {
        if (this.state.isUpdateComplete) {
            return (<TimedDisplay delay="3000" callback={this.postSubmit}>
                <Alert variant={this.state.submitMsgLvl}>{this.state.submitMsg}</Alert>
            </TimedDisplay>);
        }
        else {
            return (<></>);
        }
    }
    getCountries(countryValue) {

        if (countryValue) {
            console.log(`In getCountries with a value of ${countryValue} - getVendorCountries`);
            ServiceCalls.getVendorCountries().then(function (data) {
                if (data) {
                    if (countryValue) {
                        var selectedCountry = data.find(c => c.country === countryValue);
                        selectedCountry = (selectedCountry) ? selectedCountry : '';
                        this.setState(
                            {
                                isLoaded: true,
                                countryList: data,
                                countriesFetched: true,
                                countrySelected: true,
                                regionList: [],
                                selectedCountry: selectedCountry
                            }
                        );
                        this.getRegions(selectedCountry);
                    }
                    else {
                        this.setState(
                            {
                                isLoaded: true,
                                countryList: data,
                                countriesFetched: true
                            }
                        );
                    }
                    // this.renderForm();
                }
                else {
                    console.log(`Error fetching Vendor Countries.`);
                    this.setState({ isLoaded: false });
                }
            }.bind(this));
        }
        else {
            console.log(`In getCountries no value to lookup`);
        }
    }
    escapeRegexCharacters(str) {
        return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }
    filterCountries(country) {
        const { countryList } = this.state;
        const escapedValue = this.escapeRegexCharacters(country.trim());

        if (escapedValue === '') {
            return [];
        }
        const regex = new RegExp('^' + escapedValue, 'i');

        //Sort list
        countryList.sort(function (a, b) { return (a.description > b.description ? 1 : (a.description === b.description ? 0 : -1)) });
        return countryList.filter(c =>
            regex.test(c.description) || regex.test(c.country)
        );
    }
    filterRegions(region) {
        const { regionList } = this.state;
        return this.findRegion(regionList, region, false);
    }
    findRegion(regionList, region, byCode) {
        const searchValue = region.trim();

        if (searchValue === '') {
            return [];
        }

        //Sort list
        if (regionList) {
            regionList.sort(function (a, b) { return (a.description > b.description ? 1 : (a.description === b.description ? 0 : -1)) });
            if (byCode === true) {
                // For code matching, use EXACT match instead of "starts with"
                return regionList.filter(c =>
                    c.region.toUpperCase() === searchValue.toUpperCase()
                );
            }
            else {
                // For description matching, use "starts with" for autocomplete
                const escapedValue = this.escapeRegexCharacters(searchValue);
                const regex = new RegExp('^' + escapedValue, 'i');
                return regionList.filter(c =>
                    regex.test(c.description)
                );
            }
        }
        else {
            return region;
        }
    }
    //Lift state to ACHWarning popup component
    cancelACHWarning = (shouldContinue) => {
        if (shouldContinue) {
            this.setState({
                ACHWarningPopUpOpen: false,
            });
        }
        else {
            this.setState({
                ACHWarningPopUpOpen: false,
                isPopupOpen: false
            });
        }
    }

    openPopup() {
        const { editMode, vendorData, currentAddress } = this.props;
        //US5948444 Changed logic so it only checks if payment is ACH and not if remit addresses active is greater than 1
        var isPaymentACH = vendorData.vendorPayments.length > 0 ? vendorData.vendorPayments[0].paymentMethod : "No vendor payments";
        if ((editMode.trim().toUpperCase() === "ADD" || editMode.trim().toUpperCase() === "UPDATE") && isPaymentACH === "ACH") {
            this.setState({
                ACHWarningPopUpOpen: true,
            });
        }

        // For EDIT mode, initialize originalAddress and formData for change tracking
        if (editMode.trim().toUpperCase() === "EDIT" && currentAddress) {
            // Build full region display value
            const regionList = this.state.regionList;
            const regionDisplay = this.normalizeRegionDisplay(currentAddress.stateProvince, regionList);
            if (currentAddress.regionDescription && currentAddress.stateProvince) {
                regionDisplay = `${currentAddress.regionDescription} [${currentAddress.stateProvince}]`;
            }
            this.setState({
                originalAddress: { ...currentAddress, stateProvince: regionDisplay },
                formData: {
                    country: currentAddress.country || '',
                    address1: currentAddress.address1 || '',
                    address2: currentAddress.address2 || '',
                    address3: currentAddress.address3 || '',
                    city: currentAddress.city || '',
                    stateProvince: regionDisplay,
                    postalCode: currentAddress.postalCode || ''
                },
                isPopupOpen: true,
                isModified: false
            });
        } else {
            this.setState({
                isPopupOpen: true,
                isModified: false
            });
        }
    }

    //US8294730 “Edit” screens to not display the 'Edit' button until something on the form has changed.
    //Centralized change detection method Compares all form fields against original values using normalized formats
    calculateIsModified(updatedFormData, prevState) {
        const orig = prevState.originalAddress;
        if (!orig) return false;
        //DE1189425 Compare all fields in uppercase for alpha fields
        const countryList = prevState.countryList;
        const regionList = prevState.regionList;

        const normFormCountry = this.normalizeCountryName(updatedFormData.country, countryList);
        const normOrigCountry = this.normalizeCountryName(orig.country, countryList);
        const normFormRegion = this.normalizeRegionDisplay(updatedFormData.stateProvince, regionList);
        const normOrigRegion = this.normalizeRegionDisplay(orig.stateProvince, regionList);

        const isModified =
            (normFormCountry?.toUpperCase() ?? '') !== (normOrigCountry?.toUpperCase() ?? '') ||
            (updatedFormData.address1?.toUpperCase() ?? '') !== (orig.address1?.toUpperCase() ?? '') ||
            (updatedFormData.address2?.toUpperCase() ?? '') !== (orig.address2?.toUpperCase() ?? '') ||
            (updatedFormData.address3?.toUpperCase() ?? '') !== (orig.address3?.toUpperCase() ?? '') ||
            (updatedFormData.city?.toUpperCase() ?? '') !== (orig.city?.toUpperCase() ?? '') ||
            (normFormRegion?.toUpperCase() ?? '') !== (normOrigRegion?.toUpperCase() ?? '') ||
            (updatedFormData.postalCode?.toUpperCase() ?? '') !== (orig.postalCode?.toUpperCase() ?? '');

        console.log('isModified:', isModified, 'Form:', updatedFormData, 'Original:', orig);
        return isModified;
    }

    // updates formData and recalculates isModified
    handleFieldChange(e) {
        const { name, value } = e.target;

        // Pre-calculate outside setState
        const updatedFormData = { ...this.state.formData, [name]: value };
        const isModified = this.calculateIsModified(updatedFormData, this.state);

        // Single setState with pre-calculated values
        this.setState({
            formData: updatedFormData,
            isModified
        });
    }

    buildAddressRecord(form) {
        const { vendorData/*,editMode*/ } = this.props;
        const { selectedCountry } = this.state;
        var id = form.addressId.value;
        var status = form.addressStatus.value.toUpperCase();
        var contactCountry = (form.contactCountry) ? form.contactCountry.value.toUpperCase() : "";
        var contactAddress1 = form.contactAddress1.value.toUpperCase();
        var contactAddress2 = form.contactAddress2.value.toUpperCase();
        var contactAddress3 = form.contactAddress3.value.toUpperCase();
        var contactCity = (CommonUtils.determineVendorCityAvailable(selectedCountry) === false) ? "" : form.contactCity.value.toUpperCase();
        var contactRegion = (CommonUtils.determineVendorRegionAvailable(selectedCountry) === false) ? "" : form.contactRegion.value.toUpperCase();
        var contactPostal = (CommonUtils.determineVendorPostalAvailable(selectedCountry) === false) ? "" : form.contactPostalCode.value.toUpperCase();
        var contactAddressKey = form.contactAddressKey.value.toUpperCase();
        var contactAddressSeqNum = form.addressSeqNum.value;
        var defaultAddress = form.defaultAddress.value;
        var addressLocations = (form.addressLocations) ? form.addressLocations.value : "";
        var newAddress = {
            vendorAddressId: Number(id),
            vendorId: vendorData.vendorId,
            vendorSetId: vendorData.vendorSetId,
            vendorRecordId: vendorData.vendorRecordId,
            effStatus: status,
            addressType: "BUSN",
            country: contactCountry,
            address1: contactAddress1,
            address2: contactAddress2,
            address3: contactAddress3,
            city: contactCity,
            addressSequenceNumber: Number(contactAddressSeqNum),
            stateProvince: contactRegion,
            postalCode: contactPostal,
            addressKey: contactAddressKey,
            defaultAddress: defaultAddress,
            addressLocations: addressLocations
        };
        return newAddress;
    }
    postSubmit() {
        this.resetForm();
        this.props.onAddressChange();
    }
    handleSubmit(event) {
        const { editMode } = this.props;
        const form = event.currentTarget;
        event.preventDefault();
        event.stopPropagation();

        switch (editMode.toUpperCase()) {
            case 'INACTIVATE':
                //No validation needed on Inacvtivate process
                this.setState({
                    validated: true
                });
                this.onSetInactivateSubmit(form);
                break;
            case 'SETDEFAULT':
                //No validation needed on SetDefault process
                this.setState({
                    validated: true
                });
                this.onSetDefaultSubmit(form);
                break;
            default:
                //MAKE SURE TO SUBMIT ALL VALUES IN CAP LETTERS TO DB
                //Make sure selected region is in available list
                const { regionList, countryList, selectedCountry, selectedRegion } = this.state;

                var currentCountry = (form.contactCountry) ? form.contactCountry.value : "";
                var currentRegion = (form.contactRegion) ? form.contactRegion.value : "";
                var countryCode = currentCountry;
                if (currentCountry.indexOf('[') > -1 && currentCountry.indexOf(']') > -1) {
                    //currentCountry = currentCountry.substring(currentCountry.indexOf('(') + 1, currentCountry.indexOf(')'));
                    countryCode = currentCountry.substring(currentCountry.indexOf('[') + 1, currentCountry.indexOf(']'));
                }
                //DE994143 - Some countries have square brackets in description - check to see if descriptions match before parsing
                if (typeof (selectedRegion) == 'undefined' || typeof (selectedRegion.description) == 'undefined') {
                    currentRegion = '';
                }
                else if (currentRegion.indexOf(selectedRegion.description) > -1) {
                    currentRegion = selectedRegion.region;
                }
                else if (currentRegion.indexOf('[') > -1 && currentRegion.indexOf(']') > -1) {
                    currentRegion = currentRegion.substring(currentRegion.indexOf('[') + 1, currentRegion.indexOf(']'));
                }

                var isMatchedCountry = false;
                if (countryList.length > 0) {
                    var matchedCountry = countryList.find(r => r.country.toUpperCase() === countryCode.toUpperCase());
                    if (matchedCountry !== undefined) {
                        if (form.contactCountry.value.length > 3) {
                            var matchedCountryStr = `${matchedCountry.description} [${matchedCountry.country}]`;
                            isMatchedCountry = matchedCountryStr === form.contactCountry.value;
                        }
                        else {
                            isMatchedCountry = true;
                        }
                    }

                    // isMatchedCountry = (matchedCountry > -1);
                }
                else {
                    //Compare against current selected country
                    //isMatchedCountry = (currentCountry === selectedCountry.country);
                    isMatchedCountry = (countryCode === selectedCountry.country);
                }
                currentCountry = countryCode;
                var matchedRegion = regionList.findIndex(r => r.region.toUpperCase() === currentRegion.toUpperCase());
                var isRegionAvail = CommonUtils.determineVendorRegionAvailable(selectedCountry);

                var isMatchedRegion = false
                if (isRegionAvail === false) {
                    isMatchedRegion = true;
                } else if (isRegionAvail === true && regionList.length === 0) {
                    isMatchedRegion = (currentRegion.trim().length > 0);
                } else {
                    isMatchedRegion = (matchedRegion > -1)
                }

                //Validate Zip Code
                var isValidPostal = false;
                var currentPostal = (form.contactPostalCode) ? form.contactPostalCode.value.toUpperCase().trim() : '';
                var isPostalAvailable = CommonUtils.determineVendorPostalAvailable(selectedCountry);
                //Reset country code
                countryCode = (selectedCountry) ? selectedCountry.countryCode : '';
                if (isPostalAvailable === false) {
                    isValidPostal = true;
                }
                else {
                    if (postcodeValidatorExistsForCountry(countryCode)) {
                        console.log(`Validation Postal code for Country: ${countryCode}  Postal: ${currentPostal}`);
                        isValidPostal = postcodeValidator(currentPostal, countryCode);
                    }
                    else {
                        console.log(`Postal code Check No Validation for Country: ${countryCode}  Postal: ${currentPostal}`);
                        //If Postal is available, but no validation field is optional.
                        isValidPostal = true;
                    }
                }
                //Send back validation errors
                if (form.checkValidity() === false || isMatchedRegion === false || isMatchedCountry === false || isValidPostal === false) {

                    this.setState({
                        validated: (isMatchedRegion && isMatchedCountry && isValidPostal),
                        invalidRegion: !isMatchedRegion,
                        invalidCountry: !isMatchedCountry,
                        invalidPostalCode: !isValidPostal
                    });
                }
                else {
                    var country = (selectedCountry.country !== currentCountry) ? countryList.find(r => r.country.toUpperCase() === currentCountry.toUpperCase()) : selectedCountry;
                    var reg = "";
                    if (isRegionAvail !== false) {
                        //Check if user selected a value
                        if (selectedRegion) {
                            reg = (selectedRegion.region !== currentRegion) ? regionList.find(r => r.region.toUpperCase() === currentRegion.toUpperCase()) : selectedRegion;
                        }
                        else {
                            //user typed in a value - get region
                            reg = regionList.find(r => r.region.toUpperCase() === this.state.searchRegion.toUpperCase());
                        }
                    }

                    this.setState({
                        validated: true,
                        invalidRegion: !isMatchedRegion,
                        invalidCountry: !isMatchedCountry,
                        invalidPostalCode: !isValidPostal,
                        selectedCountry: country,
                        selectedRegion: (reg) ? reg : '',
                    });

                    /*var canSubmit = false;*/
                    var dupCount = form.dupCount.value;
                    //DEBUG console.log(`Has a dup count of ${dupCount}`)
                    if (Number(dupCount) === 0) {
                        //Check for duplicates
                        var dupAddress = this.checkAddressDuplicate(form);
                        if (dupAddress.length > 0) {
                            this.setState({
                                validated: true,
                                dupAddress: dupAddress,
                                invalidRegion: false,
                                invalidPostalCode: false
                            });
                        }
                        else {
                            this.onAddressUpdateSubmit(form, country, reg);
                        }
                    }
                    else {
                        this.onAddressUpdateSubmit(form, country, reg);
                    }
                }
                break;
        }
    }

    onSetInactivateSubmit(form) {
        const { currentAddress } = this.props;
        var inactiveAddress = currentAddress;
        var addresses = [];
        inactiveAddress = this.props.currentAddress;
        inactiveAddress.effStatus = 'I';
        addresses.push(inactiveAddress);
        this.submitForm(addresses);
    }

    onSetDefaultSubmit(form) {
        const { currentAddress, allAddresses } = this.props;
        var newDefAddress = currentAddress;
        var oldDefAddressId = Number(form.oldDefaultAddressId.value);
        var oldDefAddress = allAddresses.find(e => e.vendorAddressId === oldDefAddressId);
        var addresses = [];
        if (oldDefAddress) {
            newDefAddress.defaultAddress = 'Y';
            oldDefAddress.defaultAddress = 'N';
            addresses.push(newDefAddress);
            addresses.push(oldDefAddress);
            this.submitForm(addresses);
        }
        else {
            this.setState({
                isUpdating: false,
                submitMsg: "Form submission failed - Missing defaults",
                submitMsgLvl: "danger",
                isUpdateComplete: true,
            });
        }
    }
    onAddressUpdateSubmit(form, country, reg) {
        var addresses = [];
        form.contactCountry.value = country.country.toUpperCase();
        //If country has region available, check if country has regions to select
        //if no items in list (FIN), take what user entered in else build from selected region
        form.contactRegion.value = (CommonUtils.determineVendorRegionAvailable(country) === false)
            ? ""
            : (this.state.regionList.length === 0 && reg === undefined)
                ? form.contactRegion.value
                : reg.region;
        var newAddress = this.buildAddressRecord(form);
        addresses.push(newAddress);
        this.submitForm(addresses);
    }

    submitForm(addrresses) {
        this.setState({ isUpdating: true, validated: true, invalidRegion: false, invalidPostalCode: false });
        const { editMode } = this.props;
        console.log('submitForm - sending addresses:', JSON.stringify(addrresses, null, 2));
        ServiceCalls.updateVendorAddresses(addrresses).then(function (data) {
            console.log('submitForm - received response:', data);
            //Validate results
            if (data) {
                var errLvl = (data.errorMsg == null) ? "danger" : "info";
                var properMsg = (editMode.endsWith('e')) ? editMode + 'd' : (editMode.toUpperCase() === 'SETDEFAULT') ? 'Set Default' : editMode + 'ed';
                var msg = (data.errorMsg == null) ? `Unable to ${properMsg} Address` : `Successfully ${properMsg} Address`;

                this.setState({
                    isUpdating: false,
                    submitMsg: msg,
                    submitMsgLvl: errLvl,
                    isUpdateComplete: true,
                });
            }
            else {
                this.setState({
                    isUpdating: false,
                    submitMsg: "Form submission failed",
                    submitMsgLvl: "danger",
                    isUpdateComplete: true,
                });
            }
        }.bind(this));
    }
    countrySelected(event, suggestionObj) {
        //Get Regions for Selected country
        const { currentAddress } = this.props;
        const isSameCountryAsOriginal = currentAddress &&
            currentAddress.country === suggestionObj.suggestion.country;

        const regionValue = isSameCountryAsOriginal ?
            (this.state.originalAddress?.stateProvince || '') : '';
        // If reselecting the same country as original, restore original region
        // Otherwise, clear region for a new country selection
        const updatedFormData = {
            ...this.state.formData,
            country: `${suggestionObj.suggestion.description} [${suggestionObj.suggestion.country}]`,
            stateProvince: regionValue
        };

        const isModified = this.calculateIsModified(updatedFormData, this.state);

        // Simple setState with pre-calculated values
        this.setState({
            countrySelected: true,
            regionList: [],
            formData: updatedFormData,
            isModified
        });

        console.log(`In countrySelected with a value of ${suggestionObj.suggestion.country} - Getting regions`);
        this.getRegions(suggestionObj.suggestion);
    }
    getPopulatedCountry(hasPendingPayments) {
        const { currentAddress } = this.props;
        console.log(`In getPopulatedCountry with a value of ${currentAddress.country} - Getting country`);
        hasPendingPayments = (hasPendingPayments === undefined) ? null : hasPendingPayments;
        if (hasPendingPayments === true) {
            this.setState(
                {
                    isSearching: false,
                    hasPendingPayments: hasPendingPayments
                });
        }
        else {
            ServiceCalls.getVendorCountry(currentAddress.country).then(function (data) {
                if (data) {
                    //DE994143 - If State/Region unavailable, keep empty
                    if (data.stateAvailable == 'N') {
                        this.setState(
                            {
                                regionList: [],
                                selectedCountry: data,
                                selectedRegion: '',
                                isSearching: false,
                                regionsFetched: true,
                                countrySelected: true,
                                isLoaded: true,
                                hasPendingPayments: hasPendingPayments
                            }
                        );
                    }
                    else {
                        var regions = (data.regions) ? data.regions : [];
                        var region = (regions.length > 0) ? this.findRegion(data.regions, currentAddress.stateProvince, true) : null;
                        region = (region) ? region[0] : region;
                        this.setState(
                            {
                                regionList: regions,
                                selectedCountry: data,
                                selectedRegion: (region) ? region : '',
                                isSearching: false,
                                regionsFetched: true,
                                countrySelected: true,
                                isLoaded: true,
                                hasPendingPayments: hasPendingPayments
                            }
                        );
                    }
                }
                else {

                    this.setState(
                        {
                            isSearching: false,
                            hasPendingPayments: hasPendingPayments
                        });
                }
            }.bind(this));
        }
    }
    getRegions(countryObj) {
        const { currentAddress } = this.props;
        if (countryObj.country === undefined) {
            //console.log(`In getRegions with no country value`);
        }
        else if (CommonUtils.determineVendorRegionAvailable(countryObj) === false) {
            console.log(`In getRegions with a value of ${countryObj.country} - NO region`);
            this.setState(
                {
                    regionList: [],
                    selectedCountry: countryObj,
                    searchCountry: '',
                    selectedRegion: '',
                    isSearching: false
                }
            );
        }
        else {
            console.log(`In getRegions with a value of ${countryObj.country} - fetching regions`);
            //Disable until call complete
            this.setState(
                {
                    regionList: [],
                    selectedRegion: '',
                    isSearching: true
                });
            ServiceCalls.getVendorRegions(countryObj.country).then(function (data) {
                console.log(`In getRegions with a value of ${countryObj.country} - fetch complete`);
                if (data) {
                    // Check if this is the original country - if so, find and restore original region
                    const isSameCountryAsOriginal = currentAddress && currentAddress.country === countryObj.country;

                    let regionToSelect = '';
                    if (isSameCountryAsOriginal && currentAddress.stateProvince) {
                        // Find the region that matches the original stateProvince
                        const foundRegion = this.findRegion(data, currentAddress.stateProvince, true);
                        regionToSelect = foundRegion && foundRegion.length > 0 ? foundRegion[0] : '';
                        console.log(`Same country reselected - restoring region: ${currentAddress.stateProvince}`);
                    }
                    
                    // Pre-calculate formData outside setState
                    // If region was found, update formData with the region display value
                    const updatedFormData = regionToSelect ? {
                        ...this.state.formData,
                        stateProvince: `${regionToSelect.description} [${regionToSelect.region}]`
                    } : this.state.formData;

                    const isModified = this.calculateIsModified(updatedFormData, this.state);

                    // Single setState with all pre-calculated values
                    this.setState({
                        regionList: data,
                        selectedCountry: countryObj,
                        searchCountry: '',
                        selectedRegion: regionToSelect,
                        isSearching: false,
                        formData: updatedFormData,
                        isModified
                    });
                }
                else {
                    console.log(`Error fetching Regions`);
                    this.setState(
                        {
                            isSearching: false,
                        });
                }
            }.bind(this));
        }
    }
    //DE1189429 Formats the region value as "Description [RegionCode]"
    normalizeRegionDisplay(value, regionList) {
        if (!value) return '';
        const match = regionList.find(
            r => r.region.toUpperCase() === value.toUpperCase() || r.description.toUpperCase() === value.toUpperCase()
        );
        return match ? `${match.description} [${match.region}]` : value;
    }
    normalizeCountryName(value, countryList) {
        if (!value) return '';

        if (!countryList || countryList.length === 0) return value;
        // Already normalized (has brackets) - return as-is to preserve exact format
        if (value.includes('[') && value.includes(']')) {
            return value;
        }
        //DE1300359 Only normalize short codes (≤3 chars like "USA", "IOT") - longer values are descriptions/partial input
        if (value.length <= 3) {
            // Match by country code only
            const match = countryList.find(
                c => c.country.toUpperCase() === value.toUpperCase()
            );
            return match ? `${match.description} [${match.country}]` : value;
        }

        return value;
    }

    onRegionSelected(event, suggestionObj) {
        // Pre-calculate outside setState
        const regionDisplay = `${suggestionObj.suggestion.description} [${suggestionObj.suggestion.region}]`;
        const updatedFormData = {
            ...this.state.formData,
            stateProvince: regionDisplay
        };
            // Recalculate to enable/disable Edit button
        const isModified = this.calculateIsModified(updatedFormData, this.state);

        console.log(`Region selected to ${suggestionObj.suggestion.description} with a regionList of ${this.state.regionList.length}`);

        // Simple setState with pre-calculated values
        this.setState({
            selectedRegion: suggestionObj.suggestion,
            searchRegion: '',
            regionChanged: false,
            formData: updatedFormData,
            isModified
        });
    }
    onSuggestionsFetchRequested = ({ value }) => {
        this.setState({
            countryFilteredList: this.filterCountries(value)
        });
    };
    onRegionSuggestionsFetchRequested = ({ value }) => {
        this.setState({
            regionFilteredList: this.filterRegions(value)
        });
    };
    onSuggestionsClearRequested = () => {
        this.setState({
            countryFilteredList: this.state.countryList
        });
    };
    onRegionSuggestionsClearRequested = () => {
        this.setState({
            regionFilteredList: this.state.regionList
        });
    };
    renderSuggestion(suggestion) {
        return (<div className="suggestionItem">
            {suggestion.description} [{suggestion.country}]
        </div>);
    }
    renderRegionSuggestion(suggestion) {
        return (<div className="suggestionItem">
            {suggestion.description}
        </div>);
    }
    shouldRenderSuggestions(value, reason) {
        return (value); //.trim().length > 2;
    }
    getSuggestionValue(suggestion) {
        return suggestion.description;
    }
    onCountryChange = (event, { newValue, method }) => {
        if (method === 'type') {
            this.onCountryNameChange(event);
        }
    };
    // US10171336 Track country field changes as user types
    onCountryNameChange = (event) => {
        //Called when user types in country        
        if (this.state.countryList.length === 0) {
            console.log(`In onCountryNameChange with a value of ${event.target.value} -Countries do not exist`);

            // Pre-calculate outside setState
            const inputValue = event.target.value;
            const updatedFormData = {
                ...this.state.formData,
                country: inputValue
            };
            const tempState = {
                ...this.state,
                searchCountry: inputValue
            };
            const isModified = this.calculateIsModified(updatedFormData, tempState);

            this.setState({
                searchCountry: inputValue,
                isSearching: false,
                selectedRegion: '',
                invalidPostalCode: false,
                selectedCountry: '',
                regionList: [],
                formData: updatedFormData,
                isModified
            });

            this.getCountries(event.target.value);
        }
        else {
            // Clear selected country when field is cleared
            if (event.target.value === '') {
                // Pre-calculate cleared formData outside setState
                const clearedFormData = {
                    ...this.state.formData,
                    country: '',
                    stateProvince: ''
                };

                // Calculate isModified - clearing IS a change!
                const isModified = this.calculateIsModified(clearedFormData, this.state);


                // Batched: All state updates in single call
                this.setState({
                    searchCountry: '',
                    selectedCountry: '',
                    regionList: [],
                    selectedRegion: '',
                    invalidPostalCode: false,
                    formData: clearedFormData,
                    isModified
                });
                return;
            }

            //DE1310411 Detect if user is backspacing (current value is shorter than previous)
            const isBackspacing = event.target.value.length < this.state.searchCountry.length;

            var existCountry = this.state.countryList.find(c => c.country === event.target.value.toUpperCase());
            existCountry = (existCountry === undefined) ? '' : existCountry;

            if (existCountry && !isBackspacing) {
                // Valid country found - update and fetch regions
                console.log(`In onCountryNameChange with a value of ${event.target.value} - Country found`);

                // Pre-calculate outside setState
                const inputValue = event.target.value;
                const updatedFormData = {
                    ...this.state.formData,
                    country: inputValue,
                    stateProvince: '' // Clear region when country changes
                };
                const tempState = {
                    ...this.state,
                    searchCountry: inputValue
                };
                const isModified = this.calculateIsModified(updatedFormData, tempState);

                this.setState({
                    searchCountry: inputValue,
                    isSearching: false,
                    selectedRegion: '',
                    invalidRegion: false,
                    invalidPostalCode: false,
                    selectedCountry: existCountry,
                    regionList: [],
                    formData: updatedFormData,
                    isModified
                });

                this.getRegions(existCountry);
            }
            else {
                // Country not found (partial match) - track partial input
                console.log(`In onCountryNameChange with a value of ${event.target.value}`);
                 // Pre-calculate outside setState
            const inputValue = event.target.value;
            const updatedFormData = {
                ...this.state.formData,
                country: inputValue
            };
            const tempState = {
                ...this.state,
                searchCountry: inputValue
            };
            const isModified = this.calculateIsModified(updatedFormData, tempState);

            this.setState({
                searchCountry: inputValue,
                formData: updatedFormData,
                isModified
            });
            }
        }
    };

    onRegionChange = (event) => {
        //Only set if value is typed in
        if (event.type === 'change') {
            this.onRegionNameChange(event);
        }
    };
    onRegionNameChange(event) {
        //Prevent issues if autocomplete is clicked.
        if (event.target.value === undefined) {
            console.log(`Region changed but target value is empty`);
        }
        else if (this.state.regionList.length === 0) {
            console.log(`Region changed to ${event.target.value} a regionList of ${this.state.regionList.length}`);
            this.setState({
                searchRegion: event.target.value,
                regionChanged: true
            });
        }
        else {
            var existReg = this.state.regionList.find(c => c.description === event.target.value.toUpperCase() || c.region === event.target.value.toUpperCase());
            existReg = (existReg === undefined) ? '' : existReg;
            console.log(`In onRegionName with a value of ${event.target.value} - Country found  Exist: ${existReg}`);
            this.setState({
                searchRegion: event.target.value,
                regionChanged: true,
                selectedRegion: existReg
            });
        }
    }


    onRegionErrorFix(event) {
        this.setState({
            invalidRegion: false,
            searchRegion: event.target.value,
            regionChanged: true
        });
    }
    onCountryErrorFix(event) {
        var existCountry = this.state.countryList.find(c => c.country === event.target.value.toUpperCase());
        existCountry = (existCountry === undefined) ? '' : existCountry;
        this.setState({
            invalidCountry: false,
            searchCountry: event.target.value,
            invalidRegion: false,
            invalidPostalCode: false,
            selectedCountry: existCountry,
            regionList: []
        });
    }

    buildRegionSelection(currentCountry, isCountryEntered) {
        const { selectedRegion, searchRegion, countrySelected, regionFilteredList, regionList, countryList, regionsFetched,
            isSearching, invalidRegion, regionChanged, formData } = this.state;
        const regionTitle = CommonUtils.determineVendorContactRegionLabel(currentCountry);
        const regionAvail = CommonUtils.determineVendorRegionAvailable(currentCountry);
        var fieldDisabled = (!countrySelected) || (!regionAvail);
        let value = formData?.stateProvince ?? this.props.currentAddress?.stateProvince ?? '';
        if (this.props.editMode.toUpperCase() === "ADD") {
            value = (regionChanged === true) ? searchRegion :
                (selectedRegion) ? `${selectedRegion.description} [${selectedRegion.region}]` : '';
        }
        else if (this.props.editMode.toUpperCase() === "EDIT") {
            if (regionChanged === true) {
                value = searchRegion;
            }
            else if (regionList.length === 0 && regionAvail === true) {
                value = this.props.currentAddress.stateProvince;
            }
            else {
                value = (selectedRegion) ? `${selectedRegion.description} [${selectedRegion.region}]` : '';
            }
        }
        else { }


        if (regionAvail === false || isSearching) {
            return (
                <Form.Group as={Col} className="mb-3" controlId="contactRegion">
                    <Form.Label>{regionTitle}</Form.Label>
                    <Form.Control
                        type="text"
                        disabled={true}
                        placeholder={regionTitle} />
                </Form.Group>);
        }
        else if (isCountryEntered === false && countryList.length > 0) {
            //FOR ADD
            return (
                <Form.Group as={Col} className="mb-3" controlId="contactRegion">
                    <Form.Label>{regionTitle}<span className="required">*</span></Form.Label>
                    <Form.Control
                        type="text"
                        required
                        disabled={true}
                        placeholder="Select country first" />
                </Form.Group>);
        }
        else if (regionsFetched === true && regionList.length === 0) {
            //FOR ALL
            //No Regions for country - create free form input
            return (<Form.Group as={Col} className="mb-3" controlId="contactRegion">
                <Form.Label>{regionTitle}<span className="required">*</span></Form.Label>
                <Form.Control
                    type="text"
                    name="stateProvince"
                    required
                    maxLength="6"
                    isInvalid={invalidRegion}
                    onChange={e => {
                        this.handleFieldChange(e);
                        this.onRegionChange(e);
                    }}
                    disabled={fieldDisabled}
                    defaultValue={value}
                    placeholder="Enter state" />
                <Form.Control.Feedback type="invalid">
                    {regionTitle} is invalid
                </Form.Control.Feedback>
            </Form.Group>);
        }
        else if (invalidRegion === true) {
            //Region has validation errors   
            var phText = "Type in a " + regionTitle;
            return (<Form.Group as={Col} className="mb-3" controlId="contactRegion">
                <Form.Label>{regionTitle}<span className="required">*</span></Form.Label>
                <Form.Control
                    isInvalid={invalidRegion}
                    type="text"
                    name="stateProvince"
                    required
                    maxLength="6"
                    disabled={fieldDisabled}
                    onChange={e => {
                        this.handleFieldChange(e);
                        this.onRegionErrorFix(e);
                    }}
                    value={value}
                    placeholder={phText} />
                <Form.Control.Feedback type="invalid">
                    {regionTitle} is invalid
                </Form.Control.Feedback>
            </Form.Group>);
        }
        else {
            //SHOW AUTO COMPELTE
            const regionProps = {
                placeholder: `Type in a ${regionTitle}`,
                name: 'stateProvince',
                value: value,
                maxLength: 6,
                required: true,
                onChange: (e, { newValue }) => {
                    this.handleFieldChange({ target: { name: 'stateProvince', value: newValue } });
                    this.onRegionChange({ target: { value: newValue }, type: 'change' });
                },
                className: 'form-control invalid',
                id: 'contactRegion'
            };

            return (
                <Form.Group as={Col} className="mb-3" controlId="contactRegion">
                    <Form.Label>{regionTitle}<span className="required">*</span></Form.Label>
                    <Autosuggest
                        suggestions={regionFilteredList}
                        shouldRenderSuggestions={this.shouldRenderSuggestions}
                        onSuggestionsFetchRequested={this.onRegionSuggestionsFetchRequested}
                        onSuggestionsClearRequested={this.onRegionSuggestionsClearRequested}
                        onSuggestionSelected={this.onRegionSelected}
                        getSuggestionValue={this.getSuggestionValue}
                        renderSuggestion={this.renderRegionSuggestion}
                        inputProps={regionProps}
                    />
                </Form.Group>);
        }
    }
    buildAddressSelection(addressFld) {
        const { countrySelected } = this.state;
        var cntrlId = '';
        var cntrlLabel = '';
        var cntrlText = '';
        var isRequired = false;

        switch (addressFld) {
            case 1:
                cntrlId = 'contactAddress1';
                cntrlLabel = 'Address';
                cntrlText = 'Address 1 (or DBA)';
                isRequired = true;
                break;
            case 2:
                cntrlId = 'contactAddress2';
                cntrlLabel = 'Address 2';
                cntrlText = 'Address 2';

                break;
            case 3:
                cntrlId = 'contactAddress3';
                cntrlLabel = 'Address 3';
                cntrlText = 'Address 3';

                break;
            default:
        }
        if (isRequired) {
            return (
                <Form.Group as={Col} className="mb-3" controlId={cntrlId}>
                    <Form.Label>{cntrlLabel}<span className="required">*</span></Form.Label>
                    <Form.Control
                        type="text"
                        required
                        maxLength="55"
                        disabled={!countrySelected}
                        placeholder={cntrlText} />
                </Form.Group>
            );
        }
        else {
            return (
                <Form.Group as={Col} className="mb-3" controlId={cntrlId}>
                    <Form.Label>{cntrlLabel}</Form.Label>
                    <Form.Control
                        type="text"
                        maxLength="55"
                        disabled={!countrySelected}
                        placeholder={cntrlText} />
                </Form.Group>
            );
        }

    }
    buildDupAddress() {
        const { dupAddress } = this.state;
        return ((dupAddress.length > 0) ?
            <div className="dupText">
                <div>Address must be unique. Possible duplicate address has been found:
                    <div className="vendorDupAddress">
                        <span className="vendorDupAddressList">{dupAddress[0].address1}</span>
                        <span className="vendorDupAddressList">{dupAddress[0].address2}</span>
                        <span className="vendorDupAddressList">{dupAddress[0].address3}</span>
                        <span className="vendorDupAddressList">{dupAddress[0].city}, {dupAddress[0].stateProvince} {dupAddress[0].postalCode}</span>
                    </div>
                </div>
                Please <a href="/inbox" className="dupLink" title="Contact Payment Services">Contact Payment Services</a> with questions.
            </div>
            : <></>);
    }
    renderAddressError(suggestion) {
        return (
            <div className="addressDuplicateErr">
                <div>{suggestion.address1} - {suggestion.address2} - {suggestion.address3}</div>
                <div>Please <a href="/inbox" className="dupLink" title="Contact Payment Services">Contact Payment Services</a> with questions.</div>
            </div>
        );
    }
    onCityEntered(e) {
        this.setState({
            enteredCityValue: e.target.value
        });
    }
    onPostalEntered(e) {
        this.setState({
            enteredPostalValue: e.target.value
        });
    }
    renderAddAddress() {
        const { validated, countrySelected, selectedCountry, searchCountry, countryFilteredList, isUpdating, isLoaded, submitMsg,
            dupAddress, invalidCountry, invalidPostalCode, enteredCityValue, enteredPostalValue } = this.state;
        const actionBtnText = (dupAddress.length > 0) ? "Not A Duplicate" : "Add";
        const cityLbl = CommonUtils.determineVendorContactCityLabel(selectedCountry);

        const validErr = this.buildDupAddress();
        if (!isLoaded) {
            return (
                <div className="vContactPopupArea">
                    <h4 className="vContactPopupHdr">Add Remit Address</h4>
                    <div style={{ marginTop: "10px", margin: "auto", width: "100px" }}>
                        <Loading />
                    </div>
                </div>
            );
        }
        else {
            var value = (searchCountry) ? searchCountry : (selectedCountry) ? `${selectedCountry.description} [${selectedCountry.country}]` : '';
            const cityAvail = CommonUtils.determineVendorCityAvailable(selectedCountry);
            const stateAvail = CommonUtils.determineVendorRegionAvailable(selectedCountry);
            const postalAvail = CommonUtils.determineVendorPostalAvailable(selectedCountry);
            //US7955197 - If NPM postcode-validator  does not have a validator for given country, do not make it required.
            const postalValidatorAvailable = postcodeValidatorExistsForCountry(selectedCountry.countryCode);
            const requiredCity = (cityAvail === true) ? <span className="required">*</span> : <></>;
            const requiredPostal = (postalAvail === true && postalValidatorAvailable) ? <span className="required">*</span> : <></>;
            const cityValue = (cityAvail === false) ? "" : enteredCityValue;
            const postalValue = (postalAvail === false) ? "" : enteredPostalValue;
            var fieldDisabled = (!countrySelected);
            const stateDisplay = (stateAvail === true)
                ? this.buildRegionSelection(selectedCountry, countrySelected)
                : <Form.Control
                    type="hidden"
                    required
                    placeholder=""
                    id="contactRegion"
                    defaultValue="" />;
            const postalDisplay = (postalAvail === true)
                ? <Row className="mb-12">
                    <Form.Group as={Col} className="mb-3" controlId="contactPostalCode">
                        <Form.Label>Postal {requiredPostal}</Form.Label>
                        <Form.Control
                            type="text"
                            required={(postalAvail === true && postalValidatorAvailable)}
                            maxLength="12"
                            disabled={fieldDisabled || !postalAvail}
                            isInvalid={invalidPostalCode}
                            placeholder="Postal"
                            onChange={this.onPostalEntered}
                            defaultValue={postalValue} />
                        <Form.Control.Feedback type="invalid">
                            Invalid Postal Code
                        </Form.Control.Feedback>
                    </Form.Group>
                </Row>
                : <Form.Control
                    type="hidden"
                    required
                    placeholder=""
                    id="contactPostalCode"
                    defaultValue="" />;
            const countryProps = {
                placeholder: 'Type in country',
                value,
                autoFocus: true,
                id: 'contactCountry',
                required: true,
                maxLength: 3,
                className: 'form-control',
                onChange: this.onCountryChange
            };

            return (
                <div className="vContactPopupArea">
                    <h4 className="vContactPopupHdr">Add Remit Address</h4>
                    <Form noValidate validated={validated} onSubmit={this.handleSubmit}>
                        <Form.Control
                            type="hidden"
                            required
                            placeholder=""
                            id="addressId"
                            defaultValue="0" />
                        <Form.Control
                            type="hidden"
                            required
                            placeholder=""
                            id="vendorRecordId"
                            defaultValue={this.props.vendorData.vendorRecordId} />
                        <Form.Control
                            type="hidden"
                            required
                            placeholder=""
                            id="addressStatus"
                            defaultValue="A" />
                        <Form.Control
                            type="hidden"
                            required
                            placeholder=""
                            id="addressSeqNum"
                            defaultValue="0" />
                        <Form.Control
                            type="hidden"
                            required
                            placeholder=""
                            id="contactAddressKey"
                            defaultValue="     " />
                        <Form.Control
                            type="hidden"
                            required
                            placeholder=""
                            id="dupCount"
                            defaultValue={dupAddress.length} />
                        <Form.Control
                            type="hidden"
                            required
                            placeholder=""
                            id="defaultAddress"
                            defaultValue="N" />
                        <Form.Control
                            type="hidden"
                            required
                            placeholder=""
                            id="addressLocations"
                            defaultValue="" />
                        <Row className="mb-12">
                            <Form.Group as={Col} className="mb-3" controlId="contactCountry">
                                <Form.Label>Country<span className="required">*</span></Form.Label>
                                {(invalidCountry === false) ?
                                    <Autosuggest
                                        suggestions={countryFilteredList}
                                        shouldRenderSuggestions={this.shouldRenderSuggestions}
                                        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                                        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                                        onSuggestionSelected={this.countrySelected}
                                        getSuggestionValue={this.getSuggestionValue}
                                        renderSuggestion={this.renderSuggestion}
                                        inputProps={countryProps}
                                    />
                                    : <>
                                        <Form.Control
                                            type="text"
                                            required
                                            maxLength="3"
                                            placeholder="Country"
                                            isInvalid={invalidCountry}
                                            onChange={this.onCountryErrorFix}
                                            value={value} />
                                        <Form.Control.Feedback type="invalid">
                                            Invalid Country
                                        </Form.Control.Feedback>
                                    </>
                                }
                            </Form.Group>
                        </Row>
                        <Row className="mb-12">
                            {this.buildAddressSelection(1)}

                        </Row>
                        <Row className="mb-12">
                            {this.buildAddressSelection(2)}
                        </Row>
                        <Row className="mb-12">
                            {this.buildAddressSelection(3)}
                        </Row>
                        <Row className="mb-12">
                            <Form.Group as={Col} className="mb-3" controlId="contactCity">
                                <Form.Label>{cityLbl} {requiredCity}</Form.Label>
                                <Form.Control
                                    type="text"
                                    required={cityAvail}
                                    maxLength="30"
                                    disabled={fieldDisabled || !cityAvail}
                                    placeholder="City"
                                    onChange={this.onCityEntered}
                                    defaultValue={cityValue} />
                            </Form.Group>
                        </Row>
                        <Row className="mb-12">
                            {stateDisplay}
                        </Row>
                        {postalDisplay}
                        <Row>
                            <Col>
                                {validErr}
                            </Col>
                        </Row>
                        {(isUpdating) ? <Loading /> : (submitMsg) ?
                            this.showAlertMessage()
                            :
                            <Row className="mb-12">
                                <Col>
                                    <Button variant="primary" className="right vContactBtn" disabled={fieldDisabled} type="submit">{actionBtnText}</Button>
                                    <Button variant="primary" className="right vContactBtn" onClick={this.resetForm}>Cancel</Button>
                                </Col>
                            </Row>
                        }
                    </Form>
                </div>
            );
        }
    }
    renderEditAddress(currentAddress) {
        const {
            validated, dupAddress, countrySelected, selectedCountry, searchCountry, countryList, countryFilteredList,
            isLoaded, submitMsg, isUpdating, invalidCountry, invalidPostalCode, enteredCityValue, enteredPostalValue,
            formData, isModified
        } = this.state;

        var value = (searchCountry) ? searchCountry : (selectedCountry) ? `${selectedCountry.description} [${selectedCountry.country}]` : '';
        const cityLbl = CommonUtils.determineVendorContactCityLabel(selectedCountry);
        const actionBtnText = (dupAddress.length > 0) ? "Not A Duplicate" : "Edit";
        const stateAvail = CommonUtils.determineVendorRegionAvailable(selectedCountry);
        const cityAvail = CommonUtils.determineVendorCityAvailable(selectedCountry);
        const postalAvail = CommonUtils.determineVendorPostalAvailable(selectedCountry);
        const requiredCity = (cityAvail === true) ? <span className="required">*</span> : <></>;
        //US7955197 - If NPM postcode-validator  does not have a validator for given country, do not make it required.
        const postalValidatorAvailable = postcodeValidatorExistsForCountry(selectedCountry.countryCode);
        const requiredPostal = (postalAvail === true && postalValidatorAvailable) ? <span className="required">*</span> : <></>;
        const cityValue = (cityAvail === false) ? "" : (formData?.city ?? enteredCityValue);
        const stateDisplay = (stateAvail === true)
            ? this.buildRegionSelection(selectedCountry, countrySelected)
            : <Form.Control
                type="hidden"
                required
                placeholder=""
                id="contactRegion"
                defaultValue="" />;

        const postalValue = (postalAvail === false) ? "" : (formData?.postalCode ?? enteredPostalValue);
        const postalDisplay = (postalAvail === true)
            ? <Row className="mb-12">
                <Form.Group as={Col} className="mb-3" controlId="contactPostalCode">
                    <Form.Label>Postal{requiredPostal}</Form.Label>
                    <Form.Control
                        type="text"
                        name="postalCode"
                        required={(postalAvail === true && postalValidatorAvailable)}
                        disabled={!(postalAvail === true)}
                        maxLength="12"
                        placeholder="Postal"
                        isInvalid={invalidPostalCode}
                        onChange={(e) => {
                            this.handleFieldChange(e);
                            this.onPostalEntered(e);
                        }}
                        value={postalValue}
                    />
                    <Form.Control.Feedback type="invalid">
                        Invalid Postal Code
                    </Form.Control.Feedback>
                </Form.Group>
            </Row>
            : <Form.Control
                type="hidden"
                required
                placeholder=""
                id="contactPostalCode"
                defaultValue="" />;

        const countryProps = {
            placeholder: 'Type in country',
            value,
            autoFocus: true,
            id: 'contactCountry',
            required: true,
            maxLength: 20,
            className: 'form-control',
            onChange: this.onCountryChange
        };

        const countryDisplay = (searchCountry.length > 0 && (searchCountry !== this.props.currentAddress.country))
            ? (countryList.length === 0)
                ? <Loading />
                : (invalidCountry === true)
                    ? <>
                        <Form.Control
                            type="text"
                            name="country"
                            required
                            maxLength="20"
                            placeholder="Country"
                            isInvalid={invalidCountry}
                            onChange={(e) => {
                                this.handleFieldChange(e);
                                this.onCountryErrorFix(e);
                            }}
                            value={value}
                            autoFocus={true}
                        />
                        <Form.Control.Feedback type="invalid">
                            Invalid Country
                        </Form.Control.Feedback>
                    </>
                    : <Autosuggest
                        suggestions={countryFilteredList}
                        shouldRenderSuggestions={this.shouldRenderSuggestions}
                        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                        onSuggestionSelected={(e, obj) => { //DE1251981 Country list of values
                            this.countrySelected(e, obj);
                            this.setState(prevState => ({
                                formData: {
                                    ...prevState.formData,
                                    country: `${obj.suggestion.description} [${obj.suggestion.country}]`
                                }
                            }));
                            //Check if country has change after selection - not on every letter entered.
                            this.handleFieldChange(e);
                        }}
                        getSuggestionValue={this.getSuggestionValue}
                        renderSuggestion={this.renderSuggestion}
                        inputProps={countryProps}
                    />
            :
            <>
                <Form.Control
                    type="text"
                    name="country"
                    required
                    placeholder="Country"
                    isInvalid={invalidCountry}
                    onChange={(e) => {
                        this.handleFieldChange(e);      //  Track changes
                        this.onCountryNameChange(e);    //  existing logic
                    }}
                    autoFocus={true}
                    value={value}
                />
                <Form.Control.Feedback type="invalid">
                    Invalid Country
                </Form.Control.Feedback>
            </>;

        const validErr = this.buildDupAddress();

        return (
            <div className="vContactPopupArea">
                <h4 className="vContactPopupHdr">Edit Remit Address</h4>
                {(!isLoaded) ? <Loading /> :
                    <Form noValidate validated={validated} onSubmit={this.handleSubmit}>
                        <Form.Control
                            type="hidden"
                            required
                            placeholder=""
                            id="addressId"
                            defaultValue={currentAddress.vendorAddressId} />
                        <Form.Control
                            type="hidden"
                            required
                            placeholder=""
                            id="vendorRecordId"
                            defaultValue={this.props.vendorData.vendorRecordId} />
                        <Form.Control
                            type="hidden"
                            required
                            placeholder=""
                            id="addressSeqNum"
                            defaultValue={currentAddress.addressSequenceNumber} />
                        <Form.Control
                            type="hidden"
                            required
                            placeholder=""
                            id="addressStatus"
                            defaultValue={currentAddress.effStatus} />
                        <Form.Control
                            type="hidden"
                            required
                            placeholder=""
                            id="contactAddressKey"
                            defaultValue={currentAddress.addressKey} />
                        <Form.Control
                            type="hidden"
                            required
                            placeholder=""
                            id="dupCount"
                            defaultValue={dupAddress.length} />
                        <Form.Control
                            type="hidden"
                            required
                            placeholder=""
                            id="defaultAddress"
                            defaultValue={currentAddress.defaultAddress} />
                        <Form.Control
                            type="hidden"
                            required
                            placeholder=""
                            id="addressLocations"
                            defaultValue={currentAddress.addressLocations} />
                        <Row className="mb-12">
                            <Form.Group as={Col} className="mb-3" controlId="contactCountry">
                                <Form.Label>Country<span className="required">*</span></Form.Label>
                                {countryDisplay}
                            </Form.Group>
                        </Row>
                        <Row className="mb-12">
                            <Form.Group as={Col} className="mb-3" controlId="contactAddress1">
                                <Form.Label>Address<span className="required">*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    name="address1"
                                    maxLength="55"
                                    required
                                    placeholder="Address 1 (or DBA)"
                                    value={formData?.address1 ?? currentAddress.address1}
                                    onChange={this.handleFieldChange}
                                />
                            </Form.Group>
                        </Row>
                        <Row className="mb-12">
                            <Form.Group as={Col} className="mb-3" controlId="contactAddress2">
                                <Form.Label>Address 2</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="address2"
                                    maxLength="55"
                                    placeholder="Address 2"
                                    value={formData?.address2 ?? currentAddress.address2}
                                    onChange={this.handleFieldChange}
                                />
                            </Form.Group>
                        </Row>
                        <Row className="mb-12">
                            <Form.Group as={Col} className="mb-3" controlId="contactAddress3">
                                <Form.Label>Address 3</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="address3"
                                    maxLength="55"
                                    placeholder="Address 3"
                                    value={formData?.address3 ?? currentAddress.address3}
                                    onChange={this.handleFieldChange}
                                />
                            </Form.Group>
                        </Row>
                        <Row className="mb-12">
                            <Form.Group as={Col} className="mb-3" controlId="contactCity">
                                <Form.Label>{cityLbl}{requiredCity}</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="city"
                                    required={cityAvail}
                                    disabled={!cityAvail}
                                    maxLength="30"
                                    placeholder="City"
                                    value={cityValue}
                                    onChange={(e) => {
                                        this.handleFieldChange(e);
                                        this.onCityEntered(e);
                                    }}
                                />
                            </Form.Group>
                        </Row>
                        <Row className="mb-12">
                            {stateDisplay}
                        </Row>
                        {postalDisplay}
                        <Row>
                            <Col>
                                {validErr}
                            </Col>
                        </Row>
                        {(isUpdating) ? <Loading /> : (submitMsg) ?
                            this.showAlertMessage()
                            :
                            <Row className="mb-12">
                                <Col>
                                    {isModified && (
                                        <Button variant="primary" className="right vContactBtn" type="submit">{actionBtnText}</Button>
                                    )}
                                    <Button variant="primary" className="right vContactBtn" onClick={this.resetForm}>Cancel</Button>
                                </Col>
                            </Row>
                        }
                    </Form>
                }
            </div>
        );
    }
    renderRemoveAddress(currentAddress) {
        const { validated, selectedCountry, selectedRegion, isLoaded, submitMsg, isUpdating, hasPendingPayments } = this.state;
        var countryValue = (selectedCountry) ? `${selectedCountry.description} [${selectedCountry.country}]` : '';
        const regionTitle = CommonUtils.determineVendorContactRegionLabel(selectedCountry);
        const regionAvail = CommonUtils.determineVendorRegionAvailable(selectedCountry);
        var regionValue = (selectedRegion) ? `${selectedRegion.description} [${selectedRegion.region}]` : this.props.currentAddress.stateProvince;
        const cityTitle = CommonUtils.determineVendorContactCityLabel(selectedCountry);
        const cityAvail = CommonUtils.determineVendorCityAvailable(selectedCountry);
        const postalAvail = CommonUtils.determineVendorPostalAvailable(selectedCountry);
        var pendingPaymentsText = 'Unable to inactivate this address because pending payments exist, please select Supplier Inquiry in the Contact Us page for assistance.';
        if (hasPendingPayments === true) {
            console.log(`In Inactive Render with Pending Payments`);
            return (
                <div className="vContactPopupArea">
                    <h4 className="vContactPopupHdr">Inactivate Remit Address</h4>
                    <Row className="mb-12">
                        <p>{pendingPaymentsText}</p>
                    </Row>
                    <Row className="mb-12">
                        <Col>
                            <Button variant="primary" className="right vContactBtn" onClick={this.resetForm}>Close</Button>
                        </Col>
                    </Row>
                </div>
            );
        }

        return (
            <div className="vContactPopupArea">
                <h4 className="vContactPopupHdr">Inactivate Remit Address</h4>
                {(!isLoaded) ? <Loading /> :
                    <Form noValidate validated={validated} onSubmit={this.handleSubmit}>
                        <Form.Control
                            type="hidden"
                            required
                            placeholder=""
                            id="addressId"
                            defaultValue={currentAddress.vendorAddressId} />
                        <Form.Control
                            type="hidden"
                            required
                            placeholder=""
                            id="vendorRecordId"
                            defaultValue={this.props.vendorData.vendorRecordId} />
                        <Form.Control
                            type="hidden"
                            required
                            placeholder=""
                            id="addressStatus"
                            defaultValue="I" />
                        <Form.Control
                            type="hidden"
                            required
                            placeholder=""
                            id="addressSeqNum"
                            defaultValue={currentAddress.addressSequenceNumber} />
                        <Form.Control
                            type="hidden"
                            required
                            placeholder=""
                            id="contactAddressKey"
                            defaultValue={currentAddress.addressKey} />
                        <Form.Control
                            type="hidden"
                            required
                            placeholder=""
                            id="dupCount"
                            defaultValue="1" />
                        <Form.Control
                            type="hidden"
                            required
                            placeholder=""
                            id="defaultAddress"
                            defaultValue={currentAddress.defaultAddress} />
                        <Form.Control
                            type="hidden"
                            required
                            placeholder=""
                            id="addressLocations"
                            defaultValue={currentAddress.addressLocations} />
                        <Row className="mb-12">
                            <Form.Group as={Col} className="mb-3" controlId="contactCountry">
                                <Form.Label>Country</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Country"
                                    defaultValue={countryValue}
                                    readOnly
                                />
                            </Form.Group>
                        </Row>
                        <Row className="mb-12">
                            <Form.Group as={Col} className="mb-3" controlId="contactAddress1">
                                <Form.Label>Address</Form.Label>
                                <Form.Control
                                    type="text"
                                    required
                                    placeholder="Address 1 (or DBA)"
                                    defaultValue={currentAddress.address1}
                                    readOnly />
                            </Form.Group>
                        </Row>
                        <Row className="mb-12">
                            <Form.Group as={Col} className="mb-3" controlId="contactAddress2">
                                <Form.Label>Address 2</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Address 2"
                                    defaultValue={currentAddress.address2}
                                    readOnly />
                            </Form.Group>
                        </Row>
                        <Row className="mb-12">
                            <Form.Group as={Col} className="mb-3" controlId="contactAddress3">
                                <Form.Label>Address 3</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Address 3"
                                    defaultValue={currentAddress.address3}
                                    readOnly />
                            </Form.Group>
                        </Row>
                        {(cityAvail)
                            ? <Row className="mb-12">
                                <Form.Group as={Col} className="mb-3" controlId="contactCity">
                                    <Form.Label>{cityTitle}</Form.Label>
                                    <Form.Control
                                        type="text"
                                        required
                                        placeholder={cityTitle}
                                        defaultValue={currentAddress.city}
                                        readOnly />
                                </Form.Group>
                            </Row>
                            : <></>}
                        {(regionAvail)
                            ? <Row className="mb-12">
                                <Form.Group as={Col} className="mb-3" controlId="contactRegion">
                                    <Form.Label>{regionTitle}</Form.Label>
                                    <Form.Control
                                        type="text"
                                        required
                                        placeholder={regionTitle}
                                        defaultValue={regionValue}
                                        readOnly />
                                </Form.Group>
                            </Row>
                            : <></>
                        }
                        {(postalAvail)
                            ? <Row className="mb-12">
                                <Form.Group as={Col} className="mb-3" controlId="contactPostalCode">
                                    <Form.Label>Postal</Form.Label>
                                    <Form.Control
                                        type="text"
                                        required
                                        placeholder="Postal"
                                        defaultValue={currentAddress.postalCode}
                                        readOnly />
                                </Form.Group>
                            </Row>
                            : <> </>
                        }
                        {(isUpdating) ? <Loading /> : (submitMsg) ?
                            this.showAlertMessage()
                            :
                            <Row className="mb-12">
                                <Col>
                                    <Button variant="primary" className="right vContactBtn" type="submit">Inactivate</Button>
                                    <Button variant="primary" className="right vContactBtn" onClick={this.resetForm}>Cancel</Button>
                                </Col>
                            </Row>
                        }
                    </Form>
                }
            </div>
        );
    }
    renderSetDefaultAddress(currentAddress) {
        const { validated, isLoaded, submitMsg, isUpdating } = this.state;
        const actionBtnText = "Set Default";

        const currentDef = this.props.allAddresses.find(e => e.defaultAddress === 'Y');
        const currentDefAddress = (currentDef) ?
            <>
                <div><strong>Current Default Address</strong></div>
                <div>{currentDef.address1}</div>
                <div>{currentDef.address2}</div>
                <div>{currentDef.address3}</div>
                <div>{currentDef.city},{currentDef.stateProvince}  {currentDef.postalCode}</div>
            </>
            : <div className="error">Error with address</div>;
        const newDefAddress = (currentDef) ?
            <>
                <div><strong>New Default Address</strong></div>
                <div>{currentAddress.address1}</div>
                <div>{currentAddress.address2}</div>
                <div>{currentAddress.address3}</div>
                <div>{currentAddress.city},{currentAddress.stateProvince}  {currentAddress.postalCode}</div>
            </>
            : <div className="error">Error with address</div>;

        return (
            <div className="vContactPopupArea">
                <h4 className="vContactPopupHdr">Set Default Remit Address</h4>
                {(!isLoaded) ? <Loading /> :
                    <Form noValidate validated={validated} onSubmit={this.handleSubmit}>
                        <Form.Control
                            type="hidden"
                            required
                            placeholder=""
                            id="oldDefaultAddressId"
                            defaultValue={currentDef.vendorAddressId} />
                        <Row className="mb-12">
                            <div className="currentDefAddArea">
                                {currentDefAddress}
                            </div>
                        </Row>

                        <Row className="mb-12">
                            <div className="newDefAddArea">
                                {newDefAddress}
                            </div>
                        </Row>

                        <Row>
                            <Col>
                                <div className="defaultAddressText">
                                    By selecting "Set Default" you will be changing the default remit address.  Please ensure this address is correct and valid.
                                </div>
                            </Col>
                        </Row>
                        {(isUpdating) ? <Loading /> : (submitMsg) ?
                            this.showAlertMessage()
                            :
                            <Row className="mb-12">
                                <Col>
                                    {(currentDef) ?
                                        <Button variant="primary" className="right vContactBtn" type="submit">{actionBtnText}</Button>
                                        : <Button variant="primary" className="right vContactBtn" disabled={true}>{actionBtnText}</Button>
                                    }
                                    <Button variant="primary" className="right vContactBtn" onClick={this.resetForm}>Cancel</Button>

                                </Col>
                            </Row>
                        }
                    </Form>
                }
            </div>
        );
    }
    checkAddressDuplicate(form) {
        const { allAddresses } = this.props;
        const { selectedCountry, selectedRegion } = this.state;
        if (selectedCountry === null || selectedRegion === null) {
            return [];
        }
        //Get matching Country
        var enteredCountry = (selectedCountry) ? selectedCountry.country : ""; // form.contactCountry.value;
        var cntryMatch = allAddresses.filter(({ country }) => country.toUpperCase() === enteredCountry.toUpperCase());

        if (cntryMatch.length === 0) {
            return [];
        }
        //Filter to Region
        var regMatch = [];
        if (CommonUtils.determineVendorRegionAvailable(selectedCountry)) {
            var enteredRegion = (selectedRegion.region) ? selectedRegion.region : form.contactRegion.value;
            regMatch = cntryMatch.filter(({ stateProvince }) => stateProvince.toUpperCase() === enteredRegion.toUpperCase());
        }
        else {
            //Region not avail compare strings
            regMatch = cntryMatch.filter(({ stateProvince }) => stateProvince.toUpperCase() === form.contactRegion.value.toUpperCase());
        }

        if (regMatch.length === 0) {
            return [];
        }
        //Filter City
        var enteredCity = form.contactCity.value;
        var cityMatch = regMatch.filter(({ city }) => city.toUpperCase() === enteredCity.toUpperCase());

        if (cityMatch.length === 0) {
            return [];
        }
        //Filter Zip
        var enteredZip = (form.contactPostalCode) ? form.contactPostalCode.value : '';
        var zipMatch = [];
        if (enteredCountry === "USA") {
            var firstFive = enteredZip.substring(0, 5);
            zipMatch = cityMatch.filter(({ postalCode }) => postalCode.substring(0, 5).toUpperCase() === firstFive.toUpperCase());
        }
        else {
            zipMatch = cityMatch.filter(({ postalCode }) => postalCode.toUpperCase() === enteredZip.toUpperCase());
        }

        if (zipMatch.length === 0) {
            return [];
        }
        //Check Address
        var enteredA1 = form.contactAddress1.value;
        var enteredA2 = form.contactAddress2.value;
        var enteredA3 = form.contactAddress3.value;
        var matchedAddress = [];
        //filter out current Address Id
        if (this.props.editMode.toUpperCase() === 'EDIT') {
            var currentId = Number(form.addressId.value);
            zipMatch = zipMatch.filter(a => a.vendorAddressId !== currentId);
        }

        for (var x = 0; x < zipMatch.length; x++) {
            var matchCount = this.findAddressMatch(enteredA1, zipMatch[x]);
            matchCount += this.findAddressMatch(enteredA2, zipMatch[x]);
            matchCount += this.findAddressMatch(enteredA3, zipMatch[x]);
            if (matchCount > 2) {
                matchedAddress.push(zipMatch[x]);
            }
        }

        return matchedAddress;
    }
    findAddressMatch(addressLine, address) {
        var foundCount = 0;
        var wordArr = addressLine.toUpperCase().split(' ');
        //DEBUG foundCount = (form.contactAddress2.value.includes("attn")) ? 2 : 0;

        for (var i = 0; i < wordArr.length; i++) {
            var word = wordArr[i];
            if (word.length >= 1) {
                if (address.address1) {
                    if (address.address1.toUpperCase().includes(word)) {
                        foundCount++;
                    }
                }
                if (address.address2) {
                    if (address.address2.toUpperCase().includes(word)) {
                        foundCount++;
                    }
                }
                if (address.address3) {
                    if (address.address3.toUpperCase().includes(word)) {
                        foundCount++;
                    }
                }
            }
        }

        //If count is above 2 compare city,state,zip
        //DEBUG  console.log(`Found ${foundCount} matching address words`);
        return foundCount;
    }
    render() {
        const { isPopupOpen, ACHWarningPopUpOpen } = this.state;
        var btnName = (this.props.editMode.toUpperCase() === "ADD") ? "Add Remit" : (this.props.editMode.toUpperCase() === "SETDEFAULT") ? "Set Default" : this.props.editMode;
        var btnClasses = (this.props.editMode.toUpperCase() === "ADD") ? "vContactBtn " + this.props.btnClassName : "vActionBtn";
        return (
            (!isPopupOpen)
                ? <Button className={btnClasses} onClick={() => this.openPopup()}>{btnName}</Button>
                : ((ACHWarningPopUpOpen)
                    ? <ACHWarningPopUp cancelACHWarning={this.cancelACHWarning} />
                    : <Popup open={isPopupOpen} modal closeOnDocumentClick={false} closeOnEscape={true} onClose={this.resetForm}>
                        {close => (this.renderForm())}
                    </Popup>

                ));
    }
}
